import React, { useEffect, useState } from "react"
import PropTypes from "prop-types"
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import { Card, CardBody, Col, Row } from "reactstrap"
import TableContainer from "./Table/Table"
import { setIsMobile } from "store/actions"
import { useDispatch, useSelector } from "react-redux"
import moment from "moment"
import { getTeamLookup } from "store/createTeam/action"
import { getWFH, getWFHsummary } from "store/workFromHome/action"
import Filter from "./filter"
import { formatDate, groupDataByValue } from "helpers/util"
import { dropdownWfhsiftList, dropdownWorkfromHomeList } from "common/data/settings"
import { getUsersList } from "store/userlist/action"
import MobileView from "./MobileView"
import { isEmpty, orderBy } from "lodash"
import { exportWFHData } from "store/workFromHome/action"


const Index = () => {
  const dispatch = useDispatch()
  const { isMobile, detailWfhList, userList } = useSelector(state => ({
    isMobile: state.teams.isMobile,
    emplList: state?.userlist?.userlist?.data,
    detailWfhList: state?.WorkFromHome?.workfromhomedetailedSuccessList.datas,
    userList: state?.userlist?.alluserslist?.data || [],
  }));
  const orderedUserLists = orderBy(userList, 'username')
  const allUserLists = ([{ id: 0, label: 'All', value: 0 }]).concat(orderedUserLists.map(el => ({ ...el, label: el.username, value: el.id })))
  const [startDate, setStartDate] = useState(new Date())
  const [endDate, setEndDate] = useState(new Date())
  const [expandedRow, setExpandedRow] = useState(null)
  const [activeworkfromhome, setActiveworkfromhome] = useState(dropdownWorkfromHomeList[0]);
  const [activeUser, setActiveUser] = useState(allUserLists[0]);
  const [activeShift, setActiveShift] = useState(dropdownWfhsiftList[0]);
  const [handleAccordion, sethandleAccordion] = useState(false)
  const dateMatch = formatDate(startDate) === formatDate(endDate);
  const [tableData, setTableData] = useState([]);
  const [sort, setSort] = useState({
    direction: "asc",
    accessor: "date",
  })
  const onHandleFilterBtnClicked = () => {
    loadScreenworkfromhome()
  }
  const loadScreenworkfromhome = () => {
    const getData = {
      startdate: formatDate(startDate),
      enddate: formatDate(endDate),
      employeeId: activeUser.id,
      shift: activeShift?.id
    };
    dispatch(activeworkfromhome?.id == 1 ? getWFH(getData) : getWFHsummary(getData))
  }

  useEffect(() => {
    dispatch(getUsersList())
  }, [])

  useEffect(() => {
    loadScreenworkfromhome()
  }, [activeworkfromhome, activeUser, activeShift, startDate, endDate])

  const handleSubmit = e => {
    e.preventDefault()
    onHandleFilterBtnClicked()
  }

  useEffect(() => {
    dispatch(getTeamLookup())
    const handleResize = () => {
      dispatch(setIsMobile(window.innerWidth < 921))
    }
    window.addEventListener("resize", handleResize)
    return () => {
      window.removeEventListener("resize", handleResize)
    }
  }, [])

  const ExportDetailedWorkFromHomeReport = (e) => {
    e.preventDefault();
  
    const workFromHomePayload = {
      startDate: formatDate(startDate),
      endDate: formatDate(endDate),
      employeeId: activeUser?.label === "All" ? "" : activeUser?.value,
      shift: activeShift?.id || 0,
      export: true
    };
  
    dispatch(
      exportWFHData(
        workFromHomePayload,
        "export",
        "detailed_work_from_home"
      )
    );
  };


  const handleactiveworkfromhome = data => {
    setActiveworkfromhome(data)
  }

  const handleActiveShift = data => {
    setActiveShift(data)
  }

  const handleActiveUser = data => {
    setActiveUser(data)
  }
  const [selectname, setSelectname] = useState([
    {
      label: "All",
      value: "11",
    },
  ])
  const columns = React.useMemo(() => {
    const result = [
      {
        Header: " ",
        accessor: " ",
        disableFilters: true,
        sort: false,
        hidden: activeworkfromhome.id == 1 ? dateMatch : true,
        Cell: cellProps => {
          const indexValue = cellProps?.cell?.row?.original?.index
          return (
            <span>
              {expandedRow == indexValue ? (
                <span className="bx bx-minus-circle font-size-20" />
              ) : (
                <span className="bx bx-plus-circle font-size-20" />
              )}
            </span>
          )
        },
      },
      {
        Header: "Employee Id",
        accessor: "userIdentificationNumber",
        disableFilters: true,
        sort: true,
        sortDirection: sort.accessor === "days" ? sort.direction : "none",
        style: {
          minWidth: isMobile ? "" : "160px",
          textAlign: "start",
          maxWidth: isMobile ? "" : "160px",
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
        },
      },
      {
        Header: "Employee name",
        accessor: "employeeName",
        disableFilters: true,
        sort: true,
        sortDirection: sort.accessor === "days" ? sort.direction : "none",
        style: {
          minWidth: isMobile ? "" : "160px",
          textAlign: "start",
          maxWidth: isMobile ? "" : "160px",
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
        },
      },
      {
        Header: "Date",
        accessor: "date",
        disableFilters: true,
        sort: true,
        hidden: activeworkfromhome.id == 1 ? false : true,
        sortDirection: sort.accessor === "days" ? sort.direction : "none",
        style: {
          minWidth: isMobile ? "" : "160px",
          textAlign: "start",
          maxWidth: isMobile ? "" : "160px",
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
        },
        Cell: cellProps => {
          return (
            <>
              {!dateMatch ? <span style={{ opacity: 0 }}>HR-R-00008</span> : cellProps?.cell.value}
            </>
          )
        },
      },
      {
        Header: "Start Time",
        accessor: "starttime",
        disableFilters: true,
        sort: true,
        hidden: activeworkfromhome.id == 1 ? false : true,
        sortDirection: sort.accessor === "days" ? sort.direction : "none",
        style: {
          minWidth: isMobile ? "" : "160px",
          textAlign: "start",
          maxWidth: isMobile ? "" : "160px",
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
        },
        Cell: cellProps => {
          return (
            <>
              {!dateMatch ? <span style={{ opacity: 0 }}>HR-R-00008</span> : cellProps?.cell.value}
            </>
          )
        },
      },
      {
        Header: "End Time",
        accessor: "endtime",
        disableFilters: true,
        sort: true,
        hidden: activeworkfromhome.id == 1 ? false : true,
        sortDirection: sort.accessor === "days" ? sort.direction : "none",
        style: {
          minWidth: isMobile ? "" : "160px",
          textAlign: "start",
          maxWidth: isMobile ? "" : "160px",
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
        },
        Cell: cellProps => {
          return (
            <>
              {!dateMatch ? <span style={{ opacity: 0 }}>HR-R-00008</span> : cellProps?.cell.value}
            </>
          )
        },
      },
      {
        Header: "Total Hours",
        accessor: "totalHours",
        disableFilters: true,
        hidden: activeworkfromhome.id == 1 ? false : true,
        sort: true,
        sortDirection: sort.accessor === "days" ? sort.direction : "none",
        style: {
          minWidth: isMobile ? "" : "160px",
          textAlign: "start",
          maxWidth: isMobile ? "" : "160px",
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
        },
        Cell: cellProps => {
          return (
            <>
              {!dateMatch ? <span style={{ opacity: 0 }}>HR-R-00008</span> : cellProps?.cell.value}
            </>
          )
        },
      },
      {
        Header: "WFH",
        accessor: "hoursWorkedFromHome",
        disableFilters: true,
        hidden: activeworkfromhome.id == 1 ? false : true,
        sort: true,
        sortDirection: sort.accessor === "days" ? sort.direction : "none",
        style: {
          minWidth: isMobile ? "" : "160px",
          textAlign: "start",
          maxWidth: isMobile ? "" : "160px",
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
        },
        Cell: cellProps => {
          return (
            <>
              {!dateMatch ? <span style={{ opacity: 0 }}>HR-R-00008</span> : cellProps?.cell.value}
            </>
          )
        },
      },
      {
        Header: "Shift",
        accessor: "shift",
        disableFilters: true,
        hidden: activeworkfromhome.id == 1 ? false : true,
        sort: true,
        sortDirection: sort.accessor === "days" ? sort.direction : "none",
        style: {
          minWidth: isMobile ? "" : "160px",
          textAlign: "start",
          maxWidth: isMobile ? "" : "160px",
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
        },
        Cell: cellProps => {
          return (
            <>
              {!dateMatch ? <span style={{ opacity: 0 }}>HR-R-00008</span> : cellProps?.cell.value}
            </>
          )
        },
      },
      {
        Header: "No of days",
        accessor: "numberOFDays",
        disableFilters: true,
        hidden: activeworkfromhome.id == 1 ? true : false,
        sort: true,
        sortDirection: sort.accessor === "days" ? sort.direction : "none",
        style: {
          minWidth: isMobile ? "" : "160px",
          textAlign: "start",
          maxWidth: isMobile ? "" : "160px",
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
        },
      },
    ]
    return result
  }, [isMobile, activeworkfromhome, startDate, endDate, expandedRow, activeUser])

  useEffect(() => {
    if (!isEmpty(detailWfhList)) {
      const detailWfhListWithID = detailWfhList.map(el => ({ ...el, id: el.employeeId }))
      const groupedData = groupDataByValue(detailWfhList, 'employeeId')
      const GroupedWFHData = Object.entries(groupedData).map(
        ([key, value], index) => {
          const {
            employeeId,
            employeeName,
            date,
            shift,
            totalHours,
            hoursWorkedFromHome,
          } = value[0] || {}

          const data = value.map(entry => ({
            ...entry,
            starttime: entry?.starttime ? moment(entry?.starttime).format("HH:mm:ss") : '',
            endtime: entry?.endtime ? moment(entry?.endtime).format("HH:mm:ss") : '',
            child: true,
          }))
          return {
            ...value[0],
            data,
            employeeId,
            employeeName,
            date,
            shift,
            totalHours,
            hoursWorkedFromHome,
          }
        }
      )
      
      const singleWFHData = detailWfhListWithID.map(el => ({
        ...el,
        starttime: el?.starttime ? moment(el?.starttime).format("HH:mm:ss") : '',
        endtime: el?.endtime ? moment(el?.endtime).format("HH:mm:ss") : '',
      }))
      setTableData((dateMatch || activeworkfromhome.id != 1) ? singleWFHData : GroupedWFHData)
    }
    else setTableData([])
  }, [activeShift, activeworkfromhome, startDate, endDate, activeUser, isMobile, detailWfhList])

  return (
    <React.Fragment>
      <div className="page-content">
        <div className="container-fluid">
          <Breadcrumbs
            title={"Work From Home"}
            breadcrumbItem={"Work From Home"}
          />
          <Card>
            <CardBody>
              <Filter
                setStartDate={setStartDate}
                startDate={startDate}
                setEndDate={setEndDate}
                endDate={endDate}
                handleSubmit={handleSubmit}
                activeworkfromhome={activeworkfromhome}
                activeShift={activeShift}
                activeUser={activeUser}
                handleactiveworkfromhome={handleactiveworkfromhome}
                handleActiveShift={handleActiveShift}
                handleActiveUser={handleActiveUser}
                selectname={selectname}
                setSelectname={setSelectname}
                setExpandedRow={setExpandedRow}
                allUserLists={allUserLists}
                ExportDetailedWorkFromHomeReport={ExportDetailedWorkFromHomeReport} 
              />
              
              <Row>
                <Col xs="12">
                  <div className="p-0">
                    {!isMobile ? (
                      <>
                        <div className="table-mobileView ">
                          <TableContainer
                            columns={columns}
                            data={tableData}
                            activeworkfromhome={activeworkfromhome}
                            setExpandedRow={setExpandedRow}
                            expandedRow={expandedRow}
                            dateMatch={dateMatch}
                            isMobile={isMobile}
                          />
                        </div>
                      </>
                    ) : (
                      <>{tableData.map((item, index) => {
                        return (
                          <MobileView
                            key={index}
                            keyId={index}
                            user_name={item.employeeName}
                            data={item.data || []}
                            sethandleAccordion={sethandleAccordion}
                            handleAccordion={handleAccordion}
                            activeworkfromhome={activeworkfromhome}
                            item={item}
                          />
                        )
                      })}</>
                    )}
                  </div>
                </Col>
              </Row>
            </CardBody>
          </Card>
        </div>
      </div>
    </React.Fragment>
  )
}
Index.propTypes = {
  preGlobalFilteredRows: PropTypes.any,
}

export default Index
